import { FormInput } from 'src/@types';
import { getDefaultValue } from 'src/components/shared/form-elements';
import { CalculatorsStudentLoanStep2FormFields } from '../../../../../@types/features/calculators';

export const calculatorStudentLoanStep2FormFields: Record<
  keyof CalculatorsStudentLoanStep2FormFields,
  FormInput
> = {
  applicantYearlyIncome: {
    fieldName: 'applicantYearlyIncome',
    label: 'Wat is je bruto jaarinkomen?',
    type: 'currency',
    required: true,
    placeHolder: '€ 20.000',
    removeDecimals: true,
    defaultValue: getDefaultValue('45000')
  },
  applicantAge: {
    fieldName: 'applicantAge',
    label: 'Wat is je leeftijd?',
    type: 'number',
    required: true,
    placeHolder: '30',
    defaultValue: getDefaultValue('30')
  },
  partnerYearlyIncome: {
    fieldName: 'partnerYearlyIncome',
    label: 'Wat is het bruto jaarinkomen van je partner?',
    type: 'currency',
    required: true,
    placeHolder: '€ 20.000',
    removeDecimals: true,
    defaultValue: getDefaultValue('25000')
  },
  partnerAge: {
    fieldName: 'partnerAge',
    label: 'Wat is de leeftijd van je partner?',
    type: 'number',
    required: true,
    placeHolder: '30',
    defaultValue: getDefaultValue('30')
  }
};
